<div class="campaign-cta" *ngIf="ctaData" [class.has-bg-image]="hasBgImage">
    <div class="cta-bg-image" *ngIf="image.picture && image.placement === 'bg'">
        <finder-picture [picture]="image.picture"></finder-picture>
    </div>
    <div class="cta-wrapper">
        <header class="cta-header" *ngIf="!ctaData.headerData?.hidden || logo">
            <div class="cta-logo" *ngIf="logo">
                <img [src]="logo.url" [attr.alt]="logo.alt"/>
            </div>
            <finder-component-header *ngIf="!ctaData.headerData?.hidden"
                [data]="ctaData.headerData"
            ></finder-component-header>
        </header>
        <div class="cta-content" [class.gradient]="gradient" [ngClass]="cssClasses">
            <div class="cta-image" *ngIf="image.picture && image.placement === 'left'">
                <finder-picture [picture]="image.picture"></finder-picture>
            </div>
            <div class="cta-inner-content button-{{buttonAlignment}} text-{{textAlignment}}">
                <div *ngIf="formattedText" class="cta-text">
                    <span [innerHtml]="formattedText | safeHtml"></span>
                    <span class="cta-popover-container" *ngIf="!tooltip.disable">
                        <finder-icon-tooltip class="cta-popover"
                            [tooltip]="tooltip.text"
                            [title]="tooltip.title"
                            [position]="tooltip.position"
                            icon="&#58114;"
                        ></finder-icon-tooltip>
                    </span>
                </div>
                <div class="cta-button" *ngIf="showButton">
                    <finder-button
                        [href]="button.link"
                        [linkId]="button.linkId"
                        [target]="button.target"
                        [theme]="button.theme"
                    >{{button.label}}</finder-button>
                </div>
            </div>
            <div class="cta-image" *ngIf="image.picture && image.placement === 'right'">
                <finder-picture [picture]="image.picture"></finder-picture>
            </div>
        </div>
    </div>
</div>
